import { InboxMessageCriteria } from '@src/main/modules/messages/domain/message/inbox/inbox-message-criteria.interface';
import { InboxMessageRepository } from '@src/main/modules/messages/domain/message/inbox/inbox-message.repository';
import { useInboxMessages } from '@src/main/modules/messages/ui/mailbox/hooks/mailbox/useInboxMessages';
import { FormattedInboxMessage } from '@src/main/modules/messages/ui/mailbox/model/formated-message.model';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';
import { useMemo } from 'react';

export const useFormattedInboxMessages = (
  repository: InboxMessageRepository,
  criteria: InboxMessageCriteria,
) => {
  const { data, isLoading, error } = useInboxMessages(repository, criteria);

  const formattedData: PageResponse<FormattedInboxMessage> | undefined = useMemo(() => {
    if (!data) return undefined;

    const flatItems = data.items.flat();

    const formattedItems = flatItems.map((i) => ({
      id: i.messageId,
      ...i,
      sendBy: i.sendByName ? `${i.sendByName} (${i.sendBy})` : i.sendBy,
      recipients: i.recipients.map((r) =>
        r.recipientName && r.recipient !== r.recipientName
          ? `${r.recipientName} (${r.recipient})`
          : r.recipient,
      ),
    }));

    return {
      ...data,
      items: formattedItems,
    };
  }, [data]);

  return {
    data: formattedData,
    messages: formattedData?.items ?? [],
    total: formattedData?.total ?? 0,
    pageNumber: formattedData?.pageNumber ?? 0,
    pageSize: formattedData?.pageSize ?? 0,
    first: formattedData?.first ?? true,
    last: formattedData?.last ?? false,
    isLoading,
    error,
  };
};
